import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaMicrophone } from "react-icons/fa";
import DatePicker from "react-datepicker";
import axios from "axios";
import getApiBaseUrl from "../utils/api";
import "react-datepicker/dist/react-datepicker.css";

function toLocalDateString(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

function SpeakingTestReady({ mock = 1 }) {

  const navigate = useNavigate();

  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (date) => {
    setSelectedDate(date);
  };

  const handleBooking = async () => {

    if (!fullname || !email || !contact) {
      alert("❌ Please enter name, email and contact number.");
      return;
    }

    if (contact.length !== 10) {
      alert("❌ Contact number must be 10 digits.");
      return;
    }

    if (!selectedDate) {
      alert("❌ Please select a date first.");
      return;
    }

    try {

      setLoading(true);

      const res = await axios.post(
        `${getApiBaseUrl()}/appointment/request`,
        {
          fullname,
          email,
          contact,
          date: toLocalDateString(selectedDate)
        }
      );

      console.log("API RESPONSE:", res.data);

      alert(
`✅ Your speaking test appointment for ${selectedDate.toDateString()} has been submitted.

Please wait for a confirmation call from the Wizdom Center team.
Your test slot will be confirmed during the call.`
      );

      setSelectedDate(null);
      setFullname("");
      setEmail("");
      setContact("");

    } catch (error) {

      console.error("API ERROR:", error.response?.data || error.message);
      alert("❌ Failed to send appointment request.");

    } finally {

      setLoading(false);

    }
  };

  const isWeekday = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };

  const isFormComplete = fullname && email && contact && selectedDate;

  return (
    <div className="stready-page">
      <style>{`
        .stready-page {
          --accent: #166534;
          --accent-btn: #19fd91;
          --border: #d1d5db;
          --text: #111827;
          --text-muted: #6b7280;
          background: #ffffff;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          padding: 90px 16px 40px;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
          box-sizing: border-box;
        }
        .stready-page *, .stready-page *::before, .stready-page *::after {
          box-sizing: border-box;
        }

        .st-card {
          width: 100%;
          max-width: 640px;
          background: #ffffff;
          border-radius: 18px;
          border: 1px solid #e5e7eb;
          padding: 30px 34px 34px;
          box-shadow: 0 10px 26px rgba(0,0,0,0.07);
        }

        .st-title {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          color: var(--accent);
          font-size: 1.75rem;
          font-weight: 800;
          margin: 0 0 6px;
          text-align: center;
        }
        .st-title svg {
          font-size: 1.45rem;
        }
        .st-subtitle {
          text-align: center;
          color: var(--text-muted);
          font-size: 0.95rem;
          margin: 0 0 18px;
        }

        .st-instructions {
          background: #f9fafb;
          padding: 16px 18px;
          border-radius: 12px;
          border: 1px solid var(--border);
          line-height: 1.55;
          color: #374151;
          font-size: 0.92rem;
        }
        .st-instructions p {
          margin: 0 0 10px;
        }
        .st-instructions p:last-child {
          margin-bottom: 0;
        }

        .st-fields {
          margin-top: 18px;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .st-input {
          width: 100%;
          padding: 11px 13px;
          border-radius: 8px;
          border: 1px solid var(--border);
          background: #ffffff;
          color: var(--text);
          font-size: 0.94rem;
          outline: none;
          transition: border-color 0.15s ease, box-shadow 0.15s ease;
        }
        .st-input:focus {
          border-color: var(--accent-btn);
          box-shadow: 0 0 0 3px rgba(25, 253, 145, 0.18);
        }

        .st-datepicker-wrap {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 18px;
        }
        .st-date-input {
          width: 100%;
          max-width: 320px;
          padding: 12px 14px;
          border-radius: 10px;
          border: 2px solid var(--accent-btn);
          background: #ffffff;
          color: var(--text);
          font-size: 0.88rem;
          white-space: nowrap;
          text-align: center;
          cursor: pointer;
          outline: none;
          box-shadow: 0 4px 10px rgba(25,253,145,0.15);
        }

        .st-actions {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-top: 22px;
        }
        .st-submit-btn {
          width: 100%;
          max-width: 300px;
          background: var(--accent-btn);
          color: #000;
          border: none;
          padding: 12px 24px;
          border-radius: 10px;
          font-weight: 700;
          font-size: 0.95rem;
          cursor: pointer;
          box-shadow: 0 6px 16px rgba(25,253,145,0.28);
          transition: transform 0.12s ease, box-shadow 0.12s ease, opacity 0.12s ease;
        }
        .st-submit-btn:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 8px 20px rgba(25,253,145,0.34);
        }
        .st-submit-btn:disabled {
          opacity: 0.65;
          cursor: not-allowed;
        }
        .st-exit-btn {
          width: 100%;
          max-width: 300px;
          background: #ffffff;
          color: #374151;
          border: 1px solid var(--border);
          padding: 11px 24px;
          border-radius: 10px;
          font-size: 0.92rem;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.12s ease;
        }
        .st-exit-btn:hover {
          background: #f3f4f6;
        }

        @media (max-width: 640px) {
          .st-card {
            padding: 22px 20px 26px;
            border-radius: 14px;
          }
          .st-title {
            font-size: 1.4rem;
          }
          .st-title svg {
            font-size: 1.15rem;
          }
          .st-subtitle {
            font-size: 0.86rem;
          }
          .st-instructions {
            padding: 14px 15px;
            font-size: 0.86rem;
          }
        }
      `}</style>

      <div className="st-card">
        <h1 className="st-title">
          <FaMicrophone />
          Speaking Test
        </h1>

        <p className="st-subtitle">
          Prepare for your IELTS {mock === 1 ? "" : `Mock ${mock} `}Speaking assessment
        </p>

        {/* Instructions */}
        <div className="st-instructions">
          <p>• Candidates must visit the test centre location to take the test.</p>

          <p>
            • Test Centre Address: <br />
            1st Floor, Takshila Building, MG Rd, near Janatha Delux Hotel,
            Ballalbagh, Kodailbail, Mangaluru, Karnataka 575003.
          </p>

          <p>• It consists of three parts and lasts 11–14 minutes.</p>

          <p>• Please arrive at least 15 minutes early and bring valid identification.</p>

          <p>• Weekend bookings are not available.</p>
        </div>

        {/* Inputs */}
        <div className="st-fields">
          <input
            className="st-input"
            type="text"
            placeholder="Enter your full name"
            value={fullname}
            onChange={(e) => setFullname(e.target.value)}
          />

          <input
            className="st-input"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            className="st-input"
            type="tel"
            placeholder="Enter contact number"
            value={contact}
            maxLength={10}
            onChange={(e) =>
              setContact(e.target.value.replace(/\D/g, ""))
            }
          />
        </div>

        {/* Date Picker */}
        <div className="st-datepicker-wrap">
          <DatePicker
            selected={selectedDate}
            onChange={handleChange}
            filterDate={isWeekday}
            minDate={new Date()}
            dateFormat="MMMM d, yyyy"
            popperPlacement="bottom"
            placeholderText="📅 Select a date"
            customInput={<input className="st-date-input" />}
          />
        </div>

        {/* Actions */}
        <div className="st-actions">
          {isFormComplete && (
            <button
              className="st-submit-btn"
              onClick={handleBooking}
              disabled={loading}
            >
              {loading ? "Sending..." : "Request Appointment"}
            </button>
          )}

          <button className="st-exit-btn" onClick={() => navigate("/")}>
            Exit Module
          </button>
        </div>
      </div>
    </div>
  );
}

export default SpeakingTestReady;